<template>
  <v-select
    v-model="selected"
    label="Service Type"
    :items="items"
    :loading="isLoading"
    outlined
    dense
    clearable
    item-text="serviceName"
    item-value="id"
  >
    <template v-slot:selection="data">
      <v-row no-gutters class="px-2">
        <v-col cols="auto" class="pr-2">
          <v-icon small v-text="data.item.icon" />
        </v-col>
        <v-col>
          <span v-text="data.item.serviceName" />
        </v-col>
      </v-row>
    </template>
    <template v-slot:item="data">
      <v-row no-gutters class="px-2">
        <v-col cols="auto" class="pr-2">
          <v-icon small v-text="data.item.icon" />
        </v-col>
        <v-col>
          <span v-text="data.item.serviceName" />
        </v-col>
      </v-row>
    </template>
  </v-select>
</template>

<script>
export default {
  name: "AppServicesAutocomplete",
  data: () => ({
    isLoading: false,
    items: [],
    selected: null,
  }),
  watch: {
    selected: function () {
      this.$emit("input", this.selected);
    },
  },
  mounted() {
    this.loadServices();
  },
  methods: {
    loadServices: async function () {
      const self = this;
      self.isLoading = true;
      const { data } = await axios.get("/app/services");
      self.items = data.data;
      self.isLoading = false;
    },
  },
};
</script>
